// extracted by mini-css-extract-plugin
export default {"root":"GroupMembersList_root__i8vR4"};